import {
  ADD_UPDATE_PIAGGIO_CUSTOMER_FAILURE,
  ADD_UPDATE_PIAGGIO_CUSTOMER_REQUEST,
  ADD_UPDATE_PIAGGIO_CUSTOMER_SUCCESS,
  FETCH_PIAGGIO_CUSTOMER_LIST_FAILURE,
  FETCH_PIAGGIO_CUSTOMER_LIST_REQUEST,
  FETCH_PIAGGIO_CUSTOMER_LIST_SUCCESS,
} from "./actionTypes";
import { PiaggioCustomers } from "./types";

export const fetchPiaggioCustomerListRequest = (
  url: string,
  payload: {
    pageNumber: number;
    pageSize: number;
    sortColumn: string;
    sortOrder: string;
    searchValue: string;
  }
) => ({
  type: FETCH_PIAGGIO_CUSTOMER_LIST_REQUEST,
  url,
  payload,
});

export const fetchPiaggioCustomerListSuccess = (
  piaggioCustomerList: PiaggioCustomers[],
  totalCount: number
) => ({
  type: FETCH_PIAGGIO_CUSTOMER_LIST_SUCCESS,
  payload: { piaggioCustomerList, totalCount },
});

export const fetchPiaggioCustomerListFailure = (error: string) => ({
  type: FETCH_PIAGGIO_CUSTOMER_LIST_FAILURE,
  payload: error,
});

export const addUpdatePiaggioCustomerRequest = (
  url: string,
  payload: any,
  callback: unknown
) => ({
  type: ADD_UPDATE_PIAGGIO_CUSTOMER_REQUEST,
  url,
  payload,
  callback,
});

export const addUpdatePiaggioCustomerSuccess = (successMessage: string) => ({
  type: ADD_UPDATE_PIAGGIO_CUSTOMER_SUCCESS,
  payload: { successMessage },
});

export const addUpdatePiaggioCustomerFailure = (error: string) => ({
  type: ADD_UPDATE_PIAGGIO_CUSTOMER_FAILURE,
  payload: error,
});
